import React from 'react'
import { Tab, Drawer, Button } from '@ow/comps'
import AddSubAccount from './AddSubAccount'

const AddUser = function ({ open, appId, useOrgApi, closeModal, usersMutate }) {
  const { currentOrg } = useOrgApi
  const addBySubAccount = {
    key: 'account',
    tab: '新建子账户',
    children: (
      <AddSubAccount
        appId={appId}
        currentOrg={currentOrg}
        useOrgApi={useOrgApi}
        orgId={currentOrg ? currentOrg.key : null}
        usersMutate={usersMutate}
        closeModal={closeModal}
      />
    ),
  }

  // 之前根据appType判断有几种添加方式
  // const renderTabs = () => {
  //   if (info && info.appType === 1) {
  //     return [addFromCompany, addBySubAccount, addByInvite]
  //   }
  //   if (info && info.appType === 2) {
  //     return [addByInvite]
  //   }
  //   return [addBySubAccount]
  // }

  return (
    <Drawer
      open={open}
      placement="right"
      width="80%"
      level="null"
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => {
        return (
          <Button onClick={closeModal} stroke>
            关闭
          </Button>
        )
      }}
    >
      <Tab tabBarStyle={{ padding: '0' }}>
        {[addBySubAccount].map((item) => {
          return (
            <Tab.TabPane tab={item.tab} key={item.key}>
              {item.children}
            </Tab.TabPane>
          )
        })}
      </Tab>
    </Drawer>
  )
}

export default AddUser
